import React from "react"
import SupportImage from "@/components/SupportImage"

// TODO: Make these class names scoped to this component
const Supported2faApps = () => {
  return (
    <>
      <div className="support-article__2fa">
        <div className="support-article__2fa-panel">
          <SupportImage
            src="google-authenticator"
            alt="Google Authenticator Logo"
          />
          <div className="support-article__2fa-details">
            <div>
              <span className="support-article__2fa-title">
                Google Authenticator
              </span>
            </div>
            <div>
              <span className="support-article__2fa-links">
                <a href="https://itunes.apple.com/gb/app/google-authenticator/id388497605?mt=8">
                  App Store
                </a>{" "}
                |{" "}
                <a href="https://play.google.com/store/apps/details?id=com.google.android.apps.authenticator2">
                  Play Store
                </a>
              </span>
            </div>
          </div>
        </div>

        <div className="support-article__2fa-panel">
          <SupportImage src="authy" alt="Authy Logo" />
          <div className="support-article__2fa-details">
            <div>
              <span className="support-article__2fa-title">Authy</span>
            </div>
            <div>
              <span className="support-article__2fa-links">
                <a href="https://itunes.apple.com/gb/app/authy/id494168017?mt=8">
                  App Store
                </a>{" "}
                |{" "}
                <a href="https://play.google.com/store/apps/details?id=com.authy.authy">
                  Play Store
                </a>
              </span>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default Supported2faApps
